import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full py-6 mx-auto" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = { class: "w-full border rounded-lg border-neutral-100" }
const _hoisted_5 = { class: "relative overflow-auto" }
const _hoisted_6 = { class: "absolute left-0 top-0 h-full whitespace-nowrap position w-[181px] shadow-[2px_0_16px_0px_rgb(0,0,0,0.08)]" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "px-6 py-[26px] bg-primary-100 text-sm font-semibold relative" }, " Settings ", -1)
const _hoisted_8 = { class: "pl-[181px] min-h-[500px]" }
const _hoisted_9 = { class: "flex items-center justify-between p-6 border-b border-neutral-100" }
const _hoisted_10 = { class: "flex items-center space-x-4" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_13 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_14 = { class: "flex items-center justify-center mx-auto" }

import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import UserLayout from '@/layouts/UserLayout.vue';
import SectionTitle from '@/components/partials/SectionTitle.vue';
import ViewButton from '@/components/buttons/ViewButton.vue';
import DataTable from '../Components/DataTable.vue';
import SideTab from '../Components/SideTab.vue';
import TabComponent from '@/components/partials/TabComponent.vue';

import FormOptions from '@/classes/Settings/FormOptions'

import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";


import assignValues from "@/helpers/assignValues"
import PageLoader from "@/components/loaders/PageLoader.vue"

import { useRouter } from 'vue-router';

interface FormOptionIndexInterface {
    name: string,
    route: string,
}

interface sampleDataInfo {
    fieldName: string,
    dateUpdated: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();

const loading = ref<boolean>(false);

const items = ref<FormOptionIndexInterface[]>([]);

const init = ():void => {
    FormOptions.index([])
        .then(({ data }) => {
            items.value = data;

            loading.value = false
        })
        .catch((error: any) => {
            console.log(error);
        });
}

onMounted(() => {
    init()
})

const route = useRoute();
const active_count = ref(15);

const tabs: { name: string, count: number, href: string, allowed: boolean }[] = [
    {
        name: 'All',
        count: 0,
        href: "/settings/form-options/index",
        allowed: true
    }
];

const headers: { text: string, haveSort?: boolean }[] = [
    { text: 'Field Name' },
];

const sampleData = ref<sampleDataInfo[]> ([
    { 
        fieldName: 'Comorbid',
        dateUpdated: 'Aug 26, 2022 (00:00:00)'
    },
    { 
        fieldName: 'Referral Sources',
        dateUpdated: 'Aug 26, 2022 (00:00:00)'
    },
    { 
        fieldName: 'Religions',
        dateUpdated: 'Aug 26, 2022 (00:00:00)'
    },
    { 
        fieldName: 'Relationships',
        dateUpdated: 'Aug 26, 2022 (00:00:00)'
    },
    { 
        fieldName: 'Services Sought',
        dateUpdated: 'Aug 26, 2022 (00:00:00)'
    },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SectionTitle, {
            title: "Settings",
            description: "View the relevant data and other details"
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(SideTab, { formOptionsSelected: "" })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(TabComponent, { tabs: tabs })
                  ])
                ]),
                (_unref(route).query.tab != 'activity_logs')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(DataTable, {
                        headers: headers,
                        "no-action": false,
                        count: items.value.length,
                        tableClass: "header-frm-table"
                      }, {
                        body: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                            return (_openBlock(), _createElementBlock("tr", { key: item }, [
                              _createElementVNode("td", _hoisted_12, _toDisplayString(item.name), 1),
                              _createElementVNode("td", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  _createVNode(ViewButton, {
                                    onClick: ($event: any) => (_unref(router).replace(`/settings/form-options/view/${item.route}`))
                                  }, null, 8, ["onClick"])
                                ])
                              ])
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["count"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})